<template>
    <component :is="tag" class="Grid" :style="`gap:calc( var(--scale) * ${props.gap} ); grid-template-columns: repeat( ${props.columns}, calc(100% / ${props.columns} - ( calc( var(--scale) * ${props.gap}) * ${props.columns - 1} / ${props.columns} ) ) );`">
        <slot></slot>
    </component>
</template>

<script setup>
const props = defineProps(
{
    tag     : { type: String, default: 'div' },
    columns : { type: [String, Number], default: 1 },
    gap     : { type: [String, Number], default: '0px' }
});
</script>

<style lang="scss">
.Grid
{
    display: grid;

    $gap: var(--grid-gap);
    gap: $gap;
}
</style>